import { useMutation, useQueryClient } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { INVESTOR_GET_QUERY_KEY } from '@/modules/investments/queries/useInvestor.query';

import { useInvestor } from '../hooks';

interface Orders {
  instrumentId: string;
  amountCash?: number;
  isFullLiquidation?: boolean;
}

interface RequestPayload {
  instrument_id: number;
  amount_cash?: number;
  quantity?: number;
}

interface Payload {
  amount?: number;
  preOrders?: Orders[];
  isFullLiquidation?: boolean;
}

enum TransactionOperation {
  Sell = 'SELL',
  Buy = 'BUY',
}
interface Params {
  isSellMode?: boolean;
}
export default ({ isSellMode }: Params) => {
  const queryClient = useQueryClient();
  const {
    data: { investorAccountId },
  } = useInvestor();
  const {
    mutateAsync: handleSave,
    isLoading = false,
    isSuccess,
  } = useMutation(
    (data: Payload) => {
      const isFullLiquidation = data.isFullLiquidation && !data.preOrders ? true : undefined;
      const formattedPreOrders = data.preOrders
        ? data.preOrders?.reduce((result: RequestPayload[], item) => {
            const clearedItem = _.pickBy(
              {
                instrument_id: _.toNumber(item.instrumentId),
                amount_cash:
                  item.isFullLiquidation || data.isFullLiquidation
                    ? undefined
                    : _.round(item.amountCash || 0, 2),
                side: isSellMode ? TransactionOperation.Sell : TransactionOperation.Buy,
                full_liquidation: data.isFullLiquidation ? true : !!item.isFullLiquidation,
              },
              (value) => value !== null && value !== undefined
            );

            if (item.amountCash || item.isFullLiquidation) {
              return [...result, clearedItem as unknown as RequestPayload];
            }
            return result;
          }, [])
        : undefined;
      const totalOrdersSum =
        formattedPreOrders?.reduce((result, item) => result + (item.amount_cash || 0), 0) || undefined;
      if (
        !isFullLiquidation &&
        !data.isFullLiquidation &&
        !data.amount &&
        !formattedPreOrders &&
        !totalOrdersSum
      ) {
        return Promise.reject();
      }
      return api.post(API_URL.TRADES, {
        investor_account_id: _.toNumber(investorAccountId),
        ..._.pickBy({
          full_liquidation: isFullLiquidation,
          amount: data.isFullLiquidation ? undefined : data.amount ? _.round(data.amount, 2) : undefined,
          side: isSellMode ? TransactionOperation.Sell : TransactionOperation.Buy,
          pre_orders: formattedPreOrders,
        }),
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [INVESTOR_GET_QUERY_KEY],
        });
      },
    }
  );

  return {
    handleSave,
    isLoading,
    isSuccess,
  };
};
